export class Notification {
  subject?: string;
  body?:string;
  offer?:string;
  plan?:string;
  preview_url?:string;
  thumb_url?:string;
  topics?:string;
  type?:string;
  url?:string;
  code?:string;
  isRead:boolean = false;
}
export const NotificationType = {
  TYPE_SERVICE: 'active',
  TYPE_ERROR: 'error'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/notification.ts